// extracted by mini-css-extract-plugin
export default {"banner":"iUQDSpnWAbu8iDWXFY0W","text":"EZAz4_LLvQXtzynIJ1zT","link":"rQ67DTnHIs9xW4StiRpg"};